import { render, staticRenderFns } from "./ScreenTranslucenciaNucalDoppler.vue?vue&type=template&id=d81c7018&scoped=true&"
import script from "./ScreenTranslucenciaNucalDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucalDoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucalDoppler.vue?vue&type=style&index=0&id=d81c7018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81c7018",
  null
  
)

export default component.exports